// https://clerk.com/blog/building-a-react-importExcel-page-template

import { useState } from "react";
// import { useNavigate } from "react-router-dom";
import style from "../../css/excel.module.css";
const ImportExcel = () => {
   //  const [email, setEmail] = useState("");
   //  const [nombre, setNombre] = useState("");
   //  const [password, setPassword] = useState("");
   //  const [emailError, setEmailError] = useState("");
   //  const [nombreError, setNombreError] = useState("");
   //  const [passwordError, setPasswordError] = useState("");
   const [input, setInput] = useState({
      primary: 0,
      clave: 0,
      tabla: "",
      cia:0,
   });
   //  const navigate = useNavigate();
   function verExcel() {
      var datos = document.getElementById("excel").value;

      var array = datos.split("\n");
      var kl = parseInt(input.primary);
      var clave2 = parseInt(input.clave);
      var sql = "";
      var sql2 = "";
      // 0              1           2           3
      //Codigo Interno ,Descripcion,Precio U$S, Stock
      if (parseInt(input.tabla) === 2) {
         array.forEach((element) => {
            var data = element.split("\t");
            //  kl += 1; // primary
            sql = "(" 
             data.forEach((elem) => {
                 sql += "'" + elem.replace(",", ".") + "',";
              });
            sql= sql.substring(0,sql.length-1)
            sql2 += sql;
            console.log("Data ", sql);
            kl += parseInt(1);
            clave2 += parseInt(1);
         });
         sql2 = sql2.substring(0, sql2.length - 1);
         sql2 = "Insert into producto values " + sql2;

      }
         if (parseInt(input.tabla) === 1) {
         array.forEach((element) => {
            var data = element.split("\t");
            //  kl += 1; // primary
            sql = "(" + kl + ",";
            sql += clave2 + ",";
            sql += input.cia + ",'"; // compania
            sql += data[1].trim() + "',"; // descripcion
            sql += data[2].replace(",", ".") + ","; // precio
            sql += data[3].replace(",", ".") + ",'"; // stock
            sql += data[0] + "',"; // id-prov
            sql += "1,1),"; // Status + porcentaje ganancias
            // data.forEach((elem) => {
            //     sql += "'" + elem.replace(",", ".") + "',";
            //  });
            //  //sql= sql.substring(0,sql.length-1)
            sql2 += sql;
            console.log("Data ", sql);
            kl += parseInt(1);
            clave2 += parseInt(1);
         });
         sql2 = sql2.substring(0, sql2.length - 1);
         sql2 = "Insert into producto values " + sql2;
      }
      console.log("sql2: ", sql2);
      document.getElementById("excel").value = sql2;
   }

   function handleChange(e) {
      e.preventDefault();
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
   }

   console.log("input: ", input);

   return (
      <div className={style.mainContainer}>
         <div className={style.titleContainer}>
            <div>Ingreso Masivo de datos Productos</div>
         </div>
         <br />
         <div>
            <label>Tabla :</label>
            <select
               name="tabla"
               id="tabla"
               onChange={(e) => handleChange(e)}
               value={input.tabla}
            >
               <option value="0" key="0">
                  Seleccionar
               </option>
               <option value="1" key="1">
                  Productos
               </option>
               <option value="2" key="2">
                  Insumos
               </option>
            </select>
         </div>
         <div>
            <label>Cia Id</label>
            <input
               type="number"
               id="cia"
               name="cia"
               value={input.cia}
               onChange={handleChange}
               className={style.inputEx}
               required
            ></input>
            <label>Primary Key</label>
            <input
               type="number"
               id="primary"
               name="primary"
               value={input.primary}
               onChange={handleChange}
               className={style.inputEx}
               required
            ></input>
            <label>ID del producto</label>
            <input
               type="number"
               id="clave"
               name="clave"
               value={input.clave}
               onChange={handleChange}
               className={style.inputEx}
               required
            ></input>
         </div>
         <div className="input-group mb-3">
            <textarea
               className={style.textareaEx}
               type="text"
               placeholder="Formato  : Codigo Interno ,Descripcion,Precio U$S, Stock"
               name="excel"
               id="excel"
               // value={descripcion}
               cols={7}
               rows={12}
               // onChange={(e) => setDescripcion(e.target.value)}
               required
            />
         </div>
         <br />
         <div>
            <h3>Notas</h3>
            <p className={style.blancos}>
               Campos Insumo: Archivo Completo
            </p>
            <p className={style.blancos}>
               Campos Producto: Codigo, Descripcion del Producto, Precio,Stock
            </p>
            <p className={style.blancos}>
               Los campos de importes no deben tener signos de $
            </p>
            <p className={style.blancos}>No deje campos en blanco</p>
         </div>
         <div className={style.inputContainer}>
            <input
               className={"inputButton"}
               type="button"
               onClick={verExcel}
               value={"Procesar"}
            />
         </div>
      </div>
   );
};

export default ImportExcel;
